var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7263 15.2487L14.1185 22.8049C11.4746 25.4346 6.52474 23.222 3.66994 20.3815C0.0559863 16.7532 -1.09245 12.169 1.14345 9.94702L1.7856 9.37042L2.967 8.18921L8.5779 2.62042L8.88075 1.89569L10.3075 0.890625L10.5466 1.18616L21.7263 15.2487Z",
    fill: "#E0F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9954 10.6406L19.3641 10.5938L10.3641 8.48438C8.69068 5.60156 8.64856 2.54993 10.3079 0.890625C11.0392 0.159302 11.9531 0 13.0783 0C13.6267 0 14.2174 0.0703125 14.8641 0.225037C16.7625 0.689026 18.7313 1.67816 20.4329 3.33746C20.4891 3.37976 20.5455 3.43597 20.6017 3.49219C22.8376 5.72809 23.9392 8.41864 23.9954 10.6406Z",
    fill: "#61729B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9951 10.6406L20.4326 10.5937V3.3374C20.4888 3.3797 20.5452 3.43591 20.6014 3.49213C22.8373 5.72803 23.9389 8.41858 23.9951 10.6406Z",
    fill: "#47568C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9946 10.6406V20.4844C23.9946 22.4249 22.3726 24 20.4321 24C18.4915 24 16.9164 22.3781 16.9164 20.4375V16.3735C16.9164 16.0501 16.8038 15.7266 16.579 15.4735C15.5946 14.3203 12.7539 11.564 12.6415 11.4516C11.6992 10.5093 10.9399 9.49695 10.3633 8.48438H21.8383C23.0056 8.48438 23.9946 9.47333 23.9946 10.6406Z",
    fill: "#C3EA21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9951 10.6406V20.4844C23.9951 22.4249 22.3732 24 20.4326 24V8.48438H21.8389C23.0062 8.48438 23.9951 9.47333 23.9951 10.6406Z",
    fill: "#9CDD05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7295 15.5156H21.1357V21.1406H19.7295V15.5156Z",
    fill: "#9CDD05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4326 15.5156H21.1357V21.1406H20.4326V15.5156Z",
    fill: "#66BB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56043 7.02209C1.47602 7.83765 1.56043 8.62518 1.78529 9.37042C2.02442 10.2142 2.46021 11.0017 3.07911 11.6766C4.20411 12.9142 5.8072 13.6315 7.4806 13.6315H7.73365V12.2252H7.4806C6.20087 12.2252 4.97755 11.6766 4.1197 10.7346C3.47279 10.0173 3.06501 9.13147 2.9665 8.18921C2.92438 7.85175 2.92438 7.51428 2.95258 7.16272C3.16334 5.06744 4.87903 3.30963 7.14313 2.88757L8.57758 2.62042L10.3541 0.84375L6.87598 1.50952C4.00727 2.04382 1.81348 4.32202 1.56043 7.02209Z",
    fill: "#61729B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65315 14.4157C6.83046 13.5932 6.83046 12.2549 7.65315 11.4324C8.47493 10.6104 9.81398 10.6091 10.6359 11.4324C11.4585 12.2549 11.4585 13.5932 10.6367 14.4157C9.81325 15.2391 8.47896 15.2415 7.65315 14.4157Z",
    fill: "#61729B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.e960b849f189a6a931abb36deeae8655.svg";
export { ForwardRef as ReactComponent };